import React from 'react'
import StaffReportFetch from '../../components/employeesreportscomponents/StaffReportFetch'
import { useDispatch } from 'react-redux';
import { setHeaderName } from '../../redux/actions/userActions';

function StaffPerformanceReport() {
    const dispatch = useDispatch();
    dispatch(setHeaderName('SET_HEADER_NAME', 'Reports'));
    return <StaffReportFetch isPerformance={true} />
}

export default StaffPerformanceReport
